import { imageUrl } from '@helpers/image';
import LinkButton from '@stories/Components/LinkButton/LinkButton';
import * as React from 'react';
import S from './AnnualReportCta.styles';
const AnnualReportCta = ({ cta1, cta2, image }) => {
    return (React.createElement(S.Container, null,
        cta1 && (React.createElement(S.Link, { href: cta1.url, target: cta1.target },
            image && React.createElement(S.Image, { alt: "", src: imageUrl(image, { width: 135 }) }),
            cta1.text)),
        cta2 && (React.createElement(S.CtaWrapper, null,
            React.createElement(LinkButton, { buttonType: "inverted", href: cta2.url, target: cta2.target }, cta2.text)))));
};
export default AnnualReportCta;
